import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { Constant } from 'src/assets/constant';
import { AppConfig } from '../../config-service/app.config';

@Injectable()
export class VersionHelper {

  // let deviceSystemName = 'undefined_systemName'; //  Example = iOS || Android || Web
  // let deviceModel = 'undefined_model'; // Example = iphone 6 || GeneralMobile GM6 || Chrome
  // let deviceSystemVersion = 'undefined_systemVersion'; // Example = 11.3 || 24
  // let appVersion = 'undefined_appVersion'; // Example = 1.0.0(1)
  // let bundleId = 'undefined_bundleId'; // Example = com.gaziantepkart.gaziantep || kentkart.web.gaziantepkart
  // const result = `${deviceSystemName}_${appVersion}_${deviceSystemVersion}_${deviceModel}_${bundleId}`;

  constructor(public platform: Platform) {

    // console.log( 'IOS->', this.platform.IOS );
    // console.log( 'ANDROID->', this.platform.ANDROID );
    // console.log( 'FIREFOX->', this.platform.FIREFOX );
    // console.log( 'CHROME->', this.platform.BLINK );
    // console.log( 'OPERA(WEBKIT)->', this.platform.WEBKIT );
    // console.log( 'IE->', this.platform.TRIDENT );
    // console.log( 'EDGE->', this.platform.EDGE );
    // console.log( 'SAFARI->', this.platform. SAFARI );

  }

  getBrowserModel () {

    if (this.platform.IOS) return 'IOS';
    else if (this.platform.ANDROID) return 'ANDROID';
    else if (this.platform.FIREFOX) return 'FIREFOX';
    else if (this.platform.BLINK) return 'CHROME';
    else if (this.platform.WEBKIT) return 'OPERA';
    else if (this.platform.TRIDENT) return 'IE';
    else if (this.platform.EDGE) return 'EDGE';
    else return 'OTHER';

  }

  getVersion() {

    let systemName = "Web";
    let getModel = this.getBrowserModel();
    let systemVersion = '1.0';
    let appVersion = Constant.version;
    let bundleId = AppConfig.settings.city.bundleId;
    
    let returnValue = systemName + '_' + appVersion + '_' + systemVersion + '_' + getModel + '_' + bundleId;
  
    //console.log(returnValue);

    return returnValue;
  }

}